import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';

@Component({
  selector: 'app-custom-search-bar',
  standalone: true,
  imports: [FormsModule, MatIconModule],
  template: `
    <div
      class="custom-search-bar"
      [class.expanded]="isExpanded"
      (click)="expandSearch($event)"
    >
      <mat-icon class="search-icon">search</mat-icon>
      <input
        #searchInput
        [class.hidden]="!isExpanded"
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearchChange()"
        (click)="$event.stopPropagation()"
        [placeholder]="placeholder"
      />
    </div>
  `,
  styleUrls: ['./custom-search-bar.component.scss'],
  animations: [
    trigger('expandCollapse', [
      state(
        'collapsed',
        style({
          width: '40px',
        })
      ),
      state(
        'expanded',
        style({
          width: '200px',
        })
      ),
      transition('collapsed <=> expanded', animate('300ms ease-out')),
    ]),
  ],
})
export class CustomSearchBarComponent {
  @Input() placeholder: string = 'Search';
  @Output() search = new EventEmitter<string>();

  @ViewChild('searchInput') searchInput!: ElementRef;

  searchTerm: string = '';
  isExpanded: boolean = false;

  expandSearch(event: Event) {
    event.stopPropagation();
    this.isExpanded = true;
    setTimeout(() => {
      this.searchInput.nativeElement.focus();
    }, 0);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    if (
      !this.searchInput.nativeElement.contains(event.target) &&
      !this.searchTerm
    ) {
      this.isExpanded = false;
    }
  }

  onSearchChange() {
    this.search.emit(this.searchTerm);
  }
}
